import { useSetAtom } from "jotai";
import { UseFormHandleSubmit } from "react-hook-form";
import {
  modal2Atom,
  setInfoModalAtom,
  setModal2CloseAtom,
  setModalCloseAtom,
} from "atoms/modalAtom/modalAtom";
import {
  ClientDiscountForm,
  ClientInfoForm,
} from "features/ClientInfo/ClientInfo";
import {
  useAddClient,
  useEditClient,
  useSetClientAccount,
} from "features/ClientInfo/api";
import { useClientsState } from "atoms/clientsAtom";

import { Button, EButtonVariant } from "components/Button/Button";

type Props = {
  handleClientDiscountSubmit: UseFormHandleSubmit<ClientDiscountForm>;
  handleSubmit: UseFormHandleSubmit<ClientInfoForm>;
  isEdit?: boolean;
};

export function Footer({
  handleSubmit,
  isEdit,
  handleClientDiscountSubmit,
}: Props) {
  const { clientsState, setClientsState } = useClientsState();
  const closeModal = useSetAtom(setModalCloseAtom);
  const setInfoModal = useSetAtom(setInfoModalAtom);
  const { mutate: addClient } = useAddClient();
  const { mutate: editClient } = useEditClient();
  const { mutate: setClientAccount } = useSetClientAccount();

  const handleSave = (data: ClientInfoForm) => {
    if (!data.firstname?.length) {
      return setInfoModal({
        title:
          'Необходимо заполнить "Наименование" (или "Имя", если выбрали физ. лицо)',
        atomToOpen: modal2Atom,
        setAtomClose: setModal2CloseAtom,
        height: 250,
      });
    }
    if (isEdit) {
      editClient(
        {
          ...data,
          clientgroupid: Number(data.group?.clientgroupid || 0),
          pricelistid: Number(data.pricelistid),
          streetid: Number(data.streetid),
          birthday: data.birthday || null,
          createtime: new Date().toISOString(),
          avaliable: data.avaliable ? 1 : 0,
          notverifysms: data.notverifysms ? 1 : 0,
          clientid: Number(clientsState.activeItem?.clientid || 0),
        },
        {
          onSuccess: () => {
            setClientsState((prev) => ({
              ...prev,
              activeItems: [],
              activeItem: null,
            }));
            closeModal();
          },
        }
      );
      return;
    }

    addClient(
      {
        ...data,
        clientgroupid: Number(data.group?.clientgroupid || 0),
        pricelistid: Number(data.pricelistid),
        streetid: Number(data.streetid),
        birthday: data.birthday || null,
        createtime: new Date().toISOString(),
        avaliable: data.avaliable ? 1 : 0,
        notverifysms: data.notverifysms ? 1 : 0,
      },
      { onSuccess: () => closeModal() }
    );
  };

  const handleSaveClientDiscount = (data: ClientDiscountForm) => {
    if (isEdit) {
      setClientAccount({
        ...data,
        clientaccountid: clientsState.activeItem?.clientaccountid || "",
        shiftpercentsum: data.shiftpercentsum,
        avaliable: 1,
        name: clientsState.activeItem?.firstname || "",
      });
    }
  };

  return (
    <div onClick={handleClientDiscountSubmit(handleSaveClientDiscount)}>
      <Button
        variant={EButtonVariant.SECONDARY}
        icon="galochka"
        onClick={handleSubmit(handleSave)}
      >
        Сохранить
      </Button>
    </div>
  );
}
